import { Suspense, lazy } from "react";
import "bulma/css/bulma.min.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import ErrorBoundary from "./components/ErrorBoundary";
import PwaUpdateBanner from "./components/PwaUpdateBanner";

// Lazy-loaded route components — each becomes its own chunk
const LandingPage = lazy(() => import("./components/LandingPage"));
const Events = lazy(() => import("./components/Events"));
const NewEvent = lazy(() => import("./components/Event/NewEvent"));
const EditEvent = lazy(() => import("./components/Event/EditEvent"));
const Invitation = lazy(() => import("./components/Invitation"));
const Admin = lazy(() => import("./components/Admin"));
const BlogList = lazy(() => import("./components/Blog"));
const BlogPost = lazy(() => import("./components/Blog/BlogPost"));
const SignInPage = lazy(() => import("./components/SignIn"));
const SignUpPage = lazy(() => import("./components/SignUp"));
const MemoryBook = lazy(() => import("./components/MemoryBook/MemoryBook"));

const router = createBrowserRouter([
  {
    path: "/sign-in",
    element: (
      <Suspense fallback={<div />}>
        <SignInPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/sign-up",
    element: (
      <Suspense fallback={<div />}>
        <SignUpPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/sign-up/*",
    element: (
      <Suspense fallback={<div />}>
        <SignUpPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/sign-in/*",
    element: (
      <Suspense fallback={<div />}>
        <SignInPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/",
    element: (
      <Suspense fallback={<div />}>
        <LandingPage />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/events",
    element: (
      <ProtectedRoute>
        <Navigation />
        <Suspense fallback={<div />}>
          <Events />
        </Suspense>
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/new",
    element: (
      <ProtectedRoute>
        <Navigation />
        <Suspense fallback={<div />}>
          <NewEvent />
        </Suspense>
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/edit/:id",
    element: (
      <ProtectedRoute>
        <Navigation />
        <Suspense fallback={<div />}>
          <EditEvent />
        </Suspense>
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Navigation />
        <Suspense fallback={<div />}>
          <Admin />
        </Suspense>
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/invitation/:id",
    element: (
      <Suspense fallback={<div />}>
        <Invitation />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/memory/:id",
    element: (
      <Suspense fallback={<div />}>
        <MemoryBook />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/blog",
    element: (
      <Suspense fallback={<div />}>
        <BlogList />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/blog/:slug",
    element: (
      <Suspense fallback={<div />}>
        <BlogPost />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "*",
    element: <ErrorBoundary />,
  },
]);

function App() {
  return (
    <Suspense fallback={<div />}>
      <RouterProvider router={router} />
      <PwaUpdateBanner />
    </Suspense>
  );
}

export default App;
